import { Route, Routes } from "react-router";
import Login from "./login";
import AdminHome from "./admin/adminhome";
import FranchiseeHome from "./franchisee/franchiseehome";
import StaffHome from "./staff/staffhome";
function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Login/>} />
        <Route path="/admin/*" element={<AdminHome/>} />
        <Route path="/franchisee/*" element={<FranchiseeHome/>} />
        <Route path="/staff/*" element={<StaffHome/>} />
      </Routes>
    </>
  );
}
export default App;
